// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__Rqm70","defaultSelectedRow":"TableRow_defaultSelectedRow__3a3L7","ellipsisText":"TableRow_ellipsisText__o6C24","tableCell":"TableRow_tableCell__Uw9hK"};